import { Button } from "./Button"

export type ModalCloseButtonProps = {
  onClick: () => void
}

export const ModalCloseButton = ({ onClick }: ModalCloseButtonProps) => {
  return (
    <div className="fixed top-0 right-0 z-1 m-4 flex rounded-full bg-white sm:absolute">
      <Button iconNameLeft="close" variant="ghost" color="gray75" size="md" onClick={onClick} title="Schließen" />
    </div>
  )
}
